import React from 'react'
import {
  UserAvatar,
  UserDetailContainer,
  UserFallbackAvatar,
  UserGender,
  UserInfo,
  UserName,
} from './style'
import { Helper } from '@utils/index'

const getInitials = (name: string) => {
  if (!name) return '?'
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .slice(0, 2)
}

interface UserProfileProps {
  item?: any
  role?: string
}

const UserProfile: React.FC<UserProfileProps> = ({ item, role = 'user' }) => {
  const bgColor = Helper.getDynamicColor(item?.name || 'user')
  return (
    <UserDetailContainer>
      {item?.avatar ? (
        <UserAvatar
          src={`${process.env.APP_BUCKET_URL}/${item?.avatar}`}
          alt={item?.name || 'User'}
          style={{ width: '40px', height: '40px' }}
          onError={(e: any) => {
            e.target.style.display = 'none'
          }}
        />
      ) : (
        <UserFallbackAvatar
          bgColor={bgColor}
          style={{ width: '40px', height: '40px' }}
        >
          {getInitials(item?.name || '')}
        </UserFallbackAvatar>
      )}
      <UserInfo>
        <UserName>{item?.name || 'N/A'}</UserName>
        <UserGender>{item?.phoneNo || item?.infos?.gender || 'N/A'}</UserGender>
      </UserInfo>
    </UserDetailContainer>
  )
}

export default UserProfile
